'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CatalogRemote = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogRemote = exports.CatalogRemote = {
    fetchCatalogItems: function fetchCatalogItems(_ref) {
        var authToken = _ref.authToken,
            catalogIds = _ref.catalogIds,
            count = _ref.count,
            deployment = _ref.deployment,
            itemId = _ref.itemId,
            page = _ref.page;
        return new _promise2.default(function (resolve, reject) {
            var id = void 0;
            // right now we can only request one catalog at a time.
            // if we request too many, fail
            if (catalogIds instanceof Array) {
                if (catalogIds.length === 1) {
                    id = catalogIds[0];
                } else {
                    reject('Can only request one catalog at a time for catalog items');
                }
            } else {
                id = catalogIds;
            }
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/catalog/' + id + '/items', deployment);
            var query = {};
            if (global.__SERVER__ && itemId) {
                query.itemId = itemId;
                query.limit = 4;
                query.wrap = true;
            } else if (global.__SERVER__) {
                query.pageSize = count;
                query.cursor = (page - 1) * count;
            }

            request.query(query);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchCatalogsByIds: function fetchCatalogsByIds(_ref2) {
        var authToken = _ref2.authToken,
            catalogIds = _ref2.catalogIds,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/catalogs', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: catalogIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchCuratorsForCatalog: function fetchCuratorsForCatalog(_ref3) {
        var catalogId = _ref3.catalogId,
            deployment = _ref3.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>catalog/' + catalogId + '/curators', deployment);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchRegisteredCatalogs: function fetchRegisteredCatalogs(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>catalog/registration', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchUpcomingCatalogs: function fetchUpcomingCatalogs(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/upcomingcatalogs', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postCatalogItems: function postCatalogItems(_ref6) {
        var authToken = _ref6.authToken,
            catalogIds = _ref6.catalogIds,
            count = _ref6.count,
            deployment = _ref6.deployment,
            cursor = _ref6.cursor,
            itemId = _ref6.itemId,
            page = _ref6.page;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/catalog/items', deployment);
            var data = {};
            if (global.__SERVER__ && itemId) {
                data.cursor = cursor;
                data.pageSize = 4;
                data.wrap = true;
            } else if (global.__SERVER__) {
                data.pageSize = count;
                data.cursor = (page - 1) * count;
            }
            request.send((0, _extends3.default)({ ids: catalogIds }, data));

            (0, _helpers.addAuthToken)(request, authToken);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    postRegisterForCatalog: function postRegisterForCatalog(_ref7) {
        var authToken = _ref7.authToken,
            catalogId = _ref7.catalogId,
            deployment = _ref7.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/b_reg', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.query({ client_version: '4.3' });
            request.type('form');
            request.send({
                accept_terms: 1,
                cat_id: catalogId
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/catalog.js
// module id = zsa3
// module chunks = 57